var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionShareAosWhite = function SvgGeneralActionShareAosWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "general-action-shareAOS-white_svg__a",
    width: 18,
    height: 22,
    x: 3,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.75 1.5h16.5v21H3.75z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#general-action-shareAOS-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.462 21a1.29 1.29 0 0 1-1.288-1.288A1.289 1.289 0 1 1 17.462 21M6.538 13.288A1.29 1.29 0 0 1 5.25 12c0-.71.578-1.288 1.288-1.288S7.826 11.29 7.826 12a1.29 1.29 0 0 1-1.288 1.288M17.462 3c.71 0 1.288.578 1.288 1.288a1.29 1.29 0 0 1-1.288 1.288 1.29 1.29 0 0 1-1.288-1.288c0-.71.578-1.288 1.288-1.288m0 13.924a2.76 2.76 0 0 0-1.725.613L9.158 12.92c.102-.29.168-.596.168-.92a2.8 2.8 0 0 0-.171-.93l6.557-4.63c.48.392 1.083.635 1.75.635a2.788 2.788 0 1 0-2.788-2.788c0 .328.067.637.17.93L8.29 9.846a2.76 2.76 0 0 0-1.75-.634 2.788 2.788 0 1 0 0 5.576 2.76 2.76 0 0 0 1.756-.64l6.56 4.602c-.112.3-.181.623-.181.962a2.789 2.789 0 1 0 2.788-2.788",
    clipRule: "evenodd"
  }))));
};
export default SvgGeneralActionShareAosWhite;